import { render, staticRenderFns } from "./SchemePage.vue?vue&type=template&id=8e9f27e6&"
import script from "./SchemePage.vue?vue&type=script&lang=js&"
export * from "./SchemePage.vue?vue&type=script&lang=js&"
import style0 from "./SchemePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports